export const teamData = [
  {
    id: 1,
    img: "/img/teams/brain.webp",
    name: "Brian Ballinger",
    designation: "Chief Executive Officer",
    designationShortForm: "CEO",
    about:
      "Brian Ballinger, CEO of Medical Imaging Technology Services, brings extensive experience in the healthcare and health insurance industry to his leadership role. Since the company's inception in 2019, Brian has utilized his deep industry knowledge to drive innovation and deliver exceptional value to clients. His strategic direction and commitment to excellence continue to shape the company's growth and success. <br /><br /> As CEO of MITSI, Brian leads its growth. He uses his deep expertise in the healthcare and insurance industries. He delivers innovative solutions and exceptional client value.",
    language: "English",
    phone: "(615) 747-1900",
    email: "brian@mitsi.com",
    social: [
      { platform: "facebook", href: "https://www.facebook.com" },
      { platform: "instagram", href: "https://www.instagram.com" },
      { platform: "x", href: "https://x.com" },
      { platform: "linkedin", href: "https://www.linkedin.com" },
    ],
  },
  {
    id: 2,
    img: "/img/teams/jenny.webp",
    name: "Jenny Ballinger",
    designation: "Chief Operating Officer",
    designationShortForm: "COO",
    about:
      "Jenny Ballinger, co-founder and COO of Medical Imaging Technology Services, brings a proven track record as a serial entrepreneur. Since the company's founding in 2019, Jenny has leveraged her years of experience turning innovative ideas into thriving business models. Her strategic vision and operational expertise have been instrumental in driving the growth and success of Medical Imaging Technology Services. <br /><br /> As co-founder and COO of MITSI, Jenny Ballinger is an entrepreneur. She ensures excellence in operations, turning ideas into successful business models.",
    language: "English",
    phone: "(615) 747-1900",
    social: [
      { platform: "facebook", href: "https://www.facebook.com" },
      { platform: "instagram", href: "https://www.instagram.com" },
      { platform: "x", href: "https://x.com" },
      { platform: "linkedin", href: "https://www.linkedin.com" },
    ],
  },
  {
    id: 3,
    img: "/img/teams/hunter.webp",
    name: "Hunter Broadway",
    designation: "Chief Marketing Officer",
    designationShortForm: "CMO",
    about:
      "With extensive experience in marketing across diverse industries, Hunter brings a well-rounded and strategic approach to the role of VP of Marketing at Medical Imaging Technology Services. Hunter has managed marketing initiatives for one of the largest behavioral health companies in the nation and spearheaded data-driven marketing strategies at a leading media company. Now, he is dedicated to driving the growth of Medical Imaging Technology Services and its clients through innovative leadership. <br /><br /> Hunter Broadway's diverse marketing experience fuels MITSI success. It creates data-driven strategies that help the company and its clients grow in a competitive market.",
    language: "English",
    phone: "(615) 747-1900",
    social: [
      { platform: "facebook", href: "https://www.facebook.com" },
      { platform: "instagram", href: "https://www.instagram.com" },
      { platform: "x", href: "https://x.com" },
      { platform: "linkedin", href: "https://www.linkedin.com" },
    ],
  },
  {
    id: 4,
    img: "/img/teams/kaite.webp",
    name: "Katie Broadway",
    designation: "Chief Human Resources Officer",
    designationShortForm: "CHRO",
    about:
      "Katie Broadway brings years of recruiting and HR expertise across multiple sectors of healthcare. Known for her strategic leadership, she has spearheaded large-scale recruiting efforts and implemented data-driven strategies to enhance both recruitment and retention. Passionate about fostering positive workplace environments, Katie has also led initiatives that significantly improve company culture. Katie applies her extensive experience to attract top talent, drive employee engagement, and support the Medical Imaging Technology Services's mission to deliver excellence. Her dedication to aligning HR strategies with business goals ensures sustainable growth and a thriving workplace culture. <br /><br /> Katie Broadway leads HR at MITSI. She is passionate about talent and culture. She increases engagement, recruitment, and retention. This creates a motivated, successful workforce.",
    language: "English",
    phone: "(615) 747-1900",
    social: [
      { platform: "facebook", href: "https://www.facebook.com" },
      { platform: "instagram", href: "https://www.instagram.com" },
      { platform: "x", href: "https://x.com" },
      { platform: "linkedin", href: "https://www.linkedin.com" },
    ],
  },
  {
    id: 5,
    img: "/img/teams/jones.webp",
    name: "Cornell Jones Sr.",
    designation: "Chief Growth Officer",
    designationShortForm: "CGO",
    about:
      "As a 20+ year U.S. Army Veteran and accomplished business development professional, I bring a unique blend of leadership, vision, and results-driven expertise to every endeavor. My career has been defined by a proven ability to build high-performing teams, exceed sales and marketing goals, and drive growth in highly competitive industries. With over 15 years of experience in recruiting and sales—nine of which were dedicated to U.S. Army healthcare logistics and pharmacy. <br /><br /> I have honed exceptional skills in strategic planning, market analysis, and team leadership. Whether managing multi-million-dollar operations or coaching teams to achieve 115% of assigned goals, I am committed to excellence and innovation. My passion lies in helping organizations penetrate new markets, capture market share, and accelerate revenue growth with precision and purpose. With years of experience, Cornell Jones brings insights and skills to MITSI. He will increase growth and build industry partnerships.",
    language: "English",
    phone: "(615) 747-1900",
    social: [
      { platform: "facebook", href: "https://www.facebook.com" },
      { platform: "instagram", href: "https://www.instagram.com" },
      { platform: "x", href: "https://x.com" },
      { platform: "linkedin", href: "https://www.linkedin.com" },
    ],
  },
];
